import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import InventoryPage from './pages/InventoryPage';
import InventoryImportPage from './pages/InventoryImportPage';
import EditInventoryPage from './pages/EditInventoryPage';
import TrackingPage from './pages/TrackingPage';
import FinancePage from './pages/FinancePage';
import SettingsPage from './pages/SettingsPage';

export default function App() {
  useEffect(() => {
    // Initialize demo accounts if not already initialized
    if (!localStorage.getItem('demo-accounts-initialized')) {
      const demoAccounts = [
        { email: 'admin@havenly.com', password: 'Admin123', name: 'Admin User' },
        { email: 'mazen@havenly.com', password: 'SecurePass123', name: 'مازن أحمد' },
        { email: 'test@example.com', password: 'Test123456', name: 'Test User' },
      ];

      localStorage.setItem('demo-accounts', JSON.stringify(demoAccounts));
      localStorage.setItem('demo-accounts-initialized', 'true');
    }
  }, []);

  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory"
          element={
            <ProtectedRoute>
              <InventoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory/import"
          element={
            <ProtectedRoute>
              <InventoryImportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory/edit"
          element={
            <ProtectedRoute>
              <EditInventoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tracking"
          element={
            <ProtectedRoute>
              <TrackingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance"
          element={
            <ProtectedRoute>
              <FinancePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
